import { FixtureDetails } from './../models/connected-devices/fixture-details.model';
import { Magneto } from './../models/magneto.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Toro } from '../common/enumerations';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { AddEditLpcuApiModel } from '../models/add-lpcu-api.model';
import { LpcuDetails } from '../models/connected-devices/lpcu-details.model';
import { DependentDevice, DevicesResponse } from '../models/dependent-device.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class DependentDeviceApiService extends ApiService {

    constructor(protected http: HttpClient, protected apiUrlService: ApiUrlService, protected localCacheManager: LocalCacheManager) {
        super(http, localCacheManager);
    }

    placeDependentDeviceInDiscoveryMode(gatewayId: number, deviceType = Toro.DeviceType.LPCU): Observable<any> {
        return this.apiRequest(this.apiUrlService.getDependentDeviceActivateDiscoveryModeUrl(gatewayId, deviceType), this.HttpMethod.Post);
    }

    cancelDependentDeviceDiscoveryMode(gatewayId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getDependentDeviceCancelDiscoveryModeUrl(gatewayId), this.HttpMethod.Post);
    }

    getLpcus(gatewayId: number, withoutPagination: boolean, pageNumber: number, pageSize: number): Observable<DevicesResponse> {
        return this.apiRequest(this.apiUrlService.getDevicesUrl(gatewayId, withoutPagination, pageNumber, pageSize), this.HttpMethod.Get)
            .pipe(
                map((response: DevicesResponse) => {
                    if (response.Devices && response.Devices !== null) {
                        const dependentDevices = [];
                        response.Devices.forEach(dependentDevice => {
                            dependentDevices.push(new DependentDevice(dependentDevice));
                        });

                        response.Devices = dependentDevices;
                    }
                    else {
                        response.Devices = [];
                    }

                    return response;
                })
            );
    }

    getDeviceDetails(deviceId: number): Observable<LpcuDetails> {
        return this.apiRequest(this.apiUrlService.getDeviceUrl(deviceId), this.HttpMethod.Get)
            .pipe(map(response => new LpcuDetails(response)));
    }

    getFixtureDetails(deviceId: number, theme: { themeOrdinalPosition: number, themeId: number }): Observable<FixtureDetails> {
        return this.apiRequest(this.apiUrlService.getFixtureDetailsUrl(deviceId, theme), this.HttpMethod.Get)
            .pipe(map(response => new FixtureDetails(response)));
    }

    scanDevice(deviceId: number, isMagneto: boolean): Observable<any> {
        return this.apiRequest(this.apiUrlService.getScanDeviceUrl(deviceId, isMagneto), this.HttpMethod.Get);
    }

    previewDevice(deviceId: number, previewDetails: any): Observable<any> {
        return this.apiRequest(this.apiUrlService.getPreviewDeviceUrl(deviceId), this.HttpMethod.Post, previewDetails);
    }

    addLpcu(gatewayId: number, addLpcuApiModel: AddEditLpcuApiModel): Observable<any> {
        return this.apiRequest(this.apiUrlService.getAddLpcuUrl(gatewayId), this.HttpMethod.Post, addLpcuApiModel);
    }

    updateLpcu(deviceId: number, addLpcuApiModel: AddEditLpcuApiModel): Observable<any> {
        return this.apiRequest(this.apiUrlService.getUpdateLpcuUrl(deviceId), this.HttpMethod.Post, addLpcuApiModel);
    }

    addMagneto(gatewayId: number, magneto: Magneto): Observable<any> {
        return this.apiRequest(this.apiUrlService.getAddMagnetoUrl(gatewayId), this.HttpMethod.Post, magneto);
    }

    updateMagneto(deviceId: number, magneto: Magneto): Observable<any> {
        return this.apiRequest(this.apiUrlService.getUpdateMagnetoUrl(deviceId), this.HttpMethod.Post, magneto);
    }

    deleteDependentDevice(deviceId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getDeleteDependentDeviceUrl(deviceId), this.HttpMethod.Post);
    }

}
